<h4 class="title14 mb-2" translate>lblParts</h4>
<div class="flexbox form-check pl-0" *ngFor="let item of partList">
    <input type="checkbox" class="" name="{{item.workId}}" [id]="item.workId-item.itemMpId"
        [value]="item.itemMpId" [(ngModel)]="item.isChecked" (change)="ManageCartParts($event)" />
    <label class="form-check-label" [for]="item.workId-item.itemMpId">{{item.partName}}
    </label>
</div>